// app.js
const $9a61038289e25e4a$var$canvas = document.getElementById("polygonCanvas");
const $9a61038289e25e4a$var$ctx = $9a61038289e25e4a$var$canvas.getContext("2d");
// import hello from "../imgs/goggins.mp4";
//HEADING
// JavaScript for changing the color
const $9a61038289e25e4a$var$textElement = document.getElementById("colorfulText");
const $9a61038289e25e4a$var$backgroundElement = document.getElementById("colorfulBackground");
const $9a61038289e25e4a$var$colors = [
    "red",
    "green",
    "blue",
    "orange",
    "purple",
    "yellow"
];
function $9a61038289e25e4a$var$changeColor() {
    // Get a random color from the array
    const color = $9a61038289e25e4a$var$colors[Math.floor(Math.random() * $9a61038289e25e4a$var$colors.length)];
    let color2 = $9a61038289e25e4a$var$colors[Math.floor(Math.random() * $9a61038289e25e4a$var$colors.length)];
    if (color === color2) color2 = "pink";
    // Set the color
    $9a61038289e25e4a$var$textElement.style.color = color;
    $9a61038289e25e4a$var$backgroundElement.style.backgroundColor = color2;
}
$9a61038289e25e4a$var$changeColor();
//POLYGON
function $9a61038289e25e4a$var$getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for(let i = 0; i < 6; i++){
        color += letters[Math.floor(Math.random() * 16)];
        console.log(color);
    }
    return color;
}
function $9a61038289e25e4a$var$drawPolygon(vertices) {
    $9a61038289e25e4a$var$ctx.clearRect(0, 0, $9a61038289e25e4a$var$canvas.width, $9a61038289e25e4a$var$canvas.height); // Clear the canvas
    $9a61038289e25e4a$var$ctx.fillStyle = $9a61038289e25e4a$var$getRandomColor();
    $9a61038289e25e4a$var$ctx.beginPath();
    $9a61038289e25e4a$var$ctx.moveTo(vertices[0].x, vertices[0].y);
    for(let i = 1; i < vertices.length; i++)$9a61038289e25e4a$var$ctx.lineTo(vertices[i].x, vertices[i].y);
    $9a61038289e25e4a$var$ctx.closePath();
    $9a61038289e25e4a$var$ctx.fill();
}
function $9a61038289e25e4a$var$getRandomPolygon() {
    const numVertices = Math.floor(Math.random() * 2) + 3; // Random vertices from 3 to 10
    const vertices = [];
    for(let i = 0; i < numVertices; i++){
        const x = Math.random() * $9a61038289e25e4a$var$canvas.width;
        const y = Math.random() * $9a61038289e25e4a$var$canvas.height;
        vertices.push({
            x: x,
            y: y
        });
    }
    return vertices;
}
// function displayVideo() {
//   const img = new Image();
//   img.onload = function () {
//     ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
//   };
//   // Change the source to an image you have access to or use an open image URL
//   img.src = hello; // Example placeholder image
// }
// video
const $9a61038289e25e4a$var$videoAttributes = function() {
    const videoElement = document.getElementById("gogginsVideo");
    videoElement.style.display = "block"; // Ensure the video is visible
    // Reset video properties
    videoElement.currentTime = 0; // Reset the video to the beginning
    videoElement.loop = false; // Ensure the video does not loop
    // Play the video automatically
    videoElement.play();
    // Prevent the user from pausing the video
    videoElement.addEventListener("pause", ()=>{
        if (!videoElement.ended) videoElement.play();
        function preventFullScreen(event) {
            if (document.fullscreenElement) document.exitFullscreen();
            else if (document.webkitFullscreenElement) // Safari
            document.webkitExitFullscreen();
            else if (document.mozFullScreenElement) // Mozilla
            document.mozCancelFullScreen();
            event.preventDefault();
        }
        videoElement.addEventListener("fullscreenchange", preventFullScreen, false);
        videoElement.addEventListener("webkitfullscreenchange", preventFullScreen, false);
        videoElement.addEventListener("mozfullscreenchange", preventFullScreen, false);
        videoElement.addEventListener("msfullscreenchange", preventFullScreen, false);
    });
    // Remove all default controls from the video
    videoElement.removeAttribute("controls");
    // Pause and optionally hide the video after it has played
    videoElement.addEventListener("ended", ()=>{
        videoElement.pause();
        videoElement.style.display = "none"; // Optionally hide the video element
    });
};
const $9a61038289e25e4a$var$polygonCount = 0;
const $9a61038289e25e4a$var$renderImage = function() {
    $9a61038289e25e4a$var$drawPolygon($9a61038289e25e4a$var$getRandomPolygon());
    if ($9a61038289e25e4a$var$polygonCount === Math.floor(Math.random() * $9a61038289e25e4a$var$colors.length)) $9a61038289e25e4a$var$videoAttributes();
};
var $9a61038289e25e4a$export$2e2bcd8739ae039 = {
    changeColor: $9a61038289e25e4a$var$changeColor,
    canvas: $9a61038289e25e4a$var$canvas,
    ctx: $9a61038289e25e4a$var$ctx,
    polygonCount: $9a61038289e25e4a$var$polygonCount,
    getRandomColor: $9a61038289e25e4a$var$getRandomColor,
    drawPolygon: $9a61038289e25e4a$var$drawPolygon,
    getRandomPolygon: $9a61038289e25e4a$var$getRandomPolygon,
    videoAttributes: // displayImage,
    $9a61038289e25e4a$var$videoAttributes,
    renderImage: $9a61038289e25e4a$var$renderImage
};


// Change the color every second
setInterval((0, $9a61038289e25e4a$export$2e2bcd8739ae039).changeColor, 2000);
// Draw the initial polygon
(0, $9a61038289e25e4a$export$2e2bcd8739ae039).drawPolygon((0, $9a61038289e25e4a$export$2e2bcd8739ae039).getRandomPolygon());
(0, $9a61038289e25e4a$export$2e2bcd8739ae039).canvas.addEventListener("click", function() {
    (0, $9a61038289e25e4a$export$2e2bcd8739ae039).renderImage();
});
// import Roulette from "./roulette.js";
// spinButton.addEventListener("click", Roulette.spin);
function $d63a8266effe4d07$var$formatDate(input) {
    // Parse the input date string assuming DD/MM/YYYY format
    const parts = input.split(/[/, :]/);
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-indexed
    // Create a Date object
    const date = new Date(year, month, day, hours, minutes);
    // Format the date into the desired output
    const formatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    });
    // Extract and reformat the date parts
    const formattedParts = formatter.formatToParts(date);
    const resultMap = {};
    formattedParts.forEach((part)=>{
        resultMap[part.type] = part.value;
    });
    // Construct the final formatted string
    return `${resultMap.year}-${resultMap.month}-${resultMap.day} ${resultMap.hour}:${resultMap.minute} UTC`;
}


//# sourceMappingURL=polygoggins.223c2c95.js.map
